import React, { useRef, forwardRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Portal } from '../Portal';
import { CosmosButton, CosmosIconArrowLeft, CosmosIconClose, CosmosMode } from '../../cosmos/web-scoped/react';

import './modal.scss';

const Modal = ({
                 show,
                 setShow,
                 hideCloseButton,
                 children,
                 className = '',
                 layout = 'default'
               }) => {
  const modalRef = useRef();

  useEffect(() => {
    const clickOutsideContent = (e) => {
      if (e.target === modalRef.current) {
        setShow(false);
      }
    };
    window.addEventListener('click', clickOutsideContent);
    return () => {
      window.removeEventListener('click', clickOutsideContent);
    };
  }, [setShow]);

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        {show &&
          <Portal useRootContainer={true}>
            <CosmosMode mode="dark">
              <motion.div
                ref={modalRef}
                className={`modal layout-${layout} ${className}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}>
                <motion.div
                  className="modal__content"
                  transition={{
                    translateY: {
                      duration: .36,
                      delay: 0,
                      ease: [0.35, 0, 0, 1]
                    }
                  }}
                  initial={{ opacity: 0, translateY: '-100px' }}
                  animate={{ opacity: 1, translateY: '0px' }}
                  exit={{ opacity: 0, translateY: '-100px' }}>
                  {!hideCloseButton && ['default', 'bare'].includes(layout) &&
                    <CosmosButton
                      class={`modal__close`}
                      onClick={() => setShow(false)}
                      kind="secondary"
                      shape="circle">
                      <CosmosIconClose slot="icon" />
                    </CosmosButton>
                  }
                  {!hideCloseButton && layout === 'interim' &&
                    <CosmosButton
                      class={`modal__close`}
                      onClick={() => setShow(false)}
                      kind="secondary"
                      shape="circle">
                      <CosmosIconArrowLeft slot="icon" />
                    </CosmosButton>
                  }
                  {children}
                </motion.div>

              </motion.div>
            </CosmosMode>
          </Portal>
        }
      </AnimatePresence>
    </>
  );
};

const ModalHeader = forwardRef(
  (props, ref) => {
    return <div className="modal__header" ref={ref}>
      {props.children}
    </div>
  });

const ModalBody = props => {
  return <div className="modal__body">
    {props.children}
  </div>
}

const ModalFooter = props => {
  return <div className="modal__footer">
    {props.children}
  </div>
}

export { Modal, ModalHeader, ModalBody, ModalFooter };
